import styled from 'styled-components'

export const StyledMapImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`
